<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 mb-1">
      <div class="breadcrumb-title border-0 mb-3 mt-md-0 mt-4">
        <app-list-header
          [title]="'RULESCOMPONENT.TITLE' | translate"
          icon="bi bi-terminal-plus"
          [$parent]="getSelf()"
        >
        </app-list-header>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-lg-6 col-12 mb-2 px-2">
            <div class="card h-100">
              <div class="card-header">
                <h6 class="m-0 py-2">
                  {{ "RULESCOMPONENT.API_RULES" | translate }}
                </h6>
              </div>
              <div class="card-body pb-0">
                <div class="row mb-3 g-2 compact-inputs dropdown-pd-none">
                  <div class="col-auto px-1">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "RULESCOMPONENT.SEARCH_PLACEHOLDER" | translate
                      }}</mat-label>
                      <input
                        matInput
                        [(ngModel)]="searchRuleItem"
                        type="text"
                        id="searchUsecase"
                        name="searchUsecase"
                      />
                    </mat-form-field>
                  </div>

                  <div class="col-auto px-1">
                    <button
                      mat-stroked-button
                      color="primary"
                      [matTooltip]="'RULESCOMPONENT.ADD' | translate"
                      matTooltipPosition="above"
                      (click)="resetForm()"
                    >
                      <mat-icon>add</mat-icon>
                      <small>{{ "RULESCOMPONENT.ADD" | translate }}</small>
                    </button>
                  </div>

                  <div class="col-auto px-1">
                    <button
                      mat-stroked-button
                      color="primary"
                      [matTooltip]="'RULESCOMPONENT.EXPORT.CSV' | translate"
                      matTooltipPosition="above"
                      (click)="exportCSV()"
                    >
                      <mat-icon>description</mat-icon>
                      <small>{{
                        "RULESCOMPONENT.EXPORT.CSV" | translate
                      }}</small>
                    </button>
                  </div>

                  <div class="col-auto px-1">
                    <button
                      mat-stroked-button
                      color="primary"
                      [matTooltip]="'RULESCOMPONENT.EXPORT.PDF' | translate"
                      matTooltipPosition="above"
                      (click)="exportPDF()"
                    >
                      <mat-icon>picture_as_pdf</mat-icon>
                      <small>{{
                        "RULESCOMPONENT.EXPORT.PDF" | translate
                      }}</small>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-container">
                      <div class="table-responsive" style="height: 500px">
                        <table class="table table-bordered table-sticky-header">
                          <thead>
                            <tr>
                              <th class="text-center">
                                {{ "RULESCOMPONENT.TABLE.SNO" | translate }}
                              </th>
                              <th>
                                {{ "RULESCOMPONENT.TABLE.NAME" | translate }}
                              </th>
                              <th>
                                {{ "RULESCOMPONENT.TABLE.RULE" | translate }}
                              </th>
                              <th>
                                {{ "RULESCOMPONENT.TABLE.ACTION" | translate }}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              *ngFor="let e of filterUsecases(); let i = index"
                            >
                              <td class="text-center">{{ pageIndex(i) }}</td>
                              <td>
                                <div class="d-flex flex-column gap-1">
                                  <span class="d-flex align-items-center">
                                    <mat-icon
                                      color="primary"
                                      class="p-0"
                                      style="font-size: 14px; height: auto"
                                      >numbers</mat-icon
                                    >
                                    {{ e.name }}
                                  </span>
                                  <span
                                    class="d-flex align-items-center text-muted"
                                  >
                                    <mat-icon
                                      class="p-0"
                                      style="font-size: 14px; height: auto"
                                      >code_blocks</mat-icon
                                    >
                                    {{ e.code }}
                                  </span>
                                </div>
                              </td>
                              <td></td>
                              <td>
                                <div class="d-flex gap-2">
                                  <button
                                    mat-stroked-button
                                    class="icon-center icon-width"
                                    color="primary"
                                    [matTooltip]="'COMMON.EDIT' | translate"
                                    (click)="get(e.id)"
                                  >
                                    <mat-icon class="icon-compact"
                                      >edit</mat-icon
                                    >
                                  </button>
                                  <button
                                    mat-stroked-button
                                    class="icon-center icon-width"
                                    color="primary"
                                    [matTooltip]="'COMMON.TEST' | translate"
                                    data-bs-toggle="modal"
                                    data-bs-target="#testModel"
                                    (click)="setTestData(e)"
                                  >
                                    <mat-icon class="icon-compact"
                                      >play_arrow</mat-icon
                                    >
                                  </button>

                                  <button
                                    mat-stroked-button
                                    class="icon-center icon-width"
                                    color="warn"
                                    [matTooltip]="'COMMON.DELETE' | translate"
                                    (click)="delete1(e.id)"
                                  >
                                    <mat-icon class="icon-compact"
                                      >delete</mat-icon
                                    >
                                  </button>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <app-list-header
                      *ngIf="isPagingShow"
                      [$parent]="getSelf()"
                    ></app-list-header>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12 mb-2 px-2">
            <div class="card h-100">
              <div class="card-header border-bottom-0">
                <form-error [form]="form"></form-error>
              </div>
              <form #roleForm="ngForm">
                <div class="card-header">
                  <h6 class="m-0 p-0">
                    {{ "RULESCOMPONENT.FORM.ADD_NEW" | translate }}
                  </h6>
                </div>
                <div class="card-body pb-0 compact-inputs dropdown-pd-none">
                  <!-- Name Field -->
                  <div class="mb-3">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "RULESCOMPONENT.FORM.PLACEHOLDER_NAME" | translate
                      }}</mat-label>
                      <input
                        matInput
                        (input)="checkValue($event)"
                        required
                        [(ngModel)]="form.data['name']"
                        name="name"
                      />
                      <mat-error *ngIf="form.inputerror['name']">
                        {{ form.inputerror["name"] }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- Rule Field -->
                  <div class="mb-3 textarea-container">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>{{
                        "RULESCOMPONENT.FORM.PLACEHOLDER_RULE" | translate
                      }}</mat-label>
                      <textarea
                        matInput
                        rows="8"
                        [(ngModel)]="form.data['rule']"
                        name="rule"
                        class="no-padding-textarea"
                      >
                      </textarea>
                    </mat-form-field>
                  </div>
                </div>

                <div class="card-footer border-0 text-end">
                  <!-- Save Button -->
                  <button
                    mat-stroked-button
                    color="primary"
                    [title]="'RULESCOMPONENT.FORM.SAVE' | translate"
                    class="me-2"
                    [disabled]="!roleForm.valid || ruleName"
                    (click)="save()"
                  >
                    <mat-icon class="icon-compact">save</mat-icon>
                    {{ "RULESCOMPONENT.FORM.SAVE" | translate }}
                  </button>

                  <!-- Delete Button -->
                  <button
                    mat-stroked-button
                    color="warn"
                    [title]="'RULESCOMPONENT.FORM.DELETE' | translate"
                    type="submit"
                    (click)="delete(form.data['id'])"
                    (click)="resetForm()"
                  >
                    <mat-icon class="icon-compact">delete</mat-icon>
                    {{ "RULESCOMPONENT.FORM.DELETE" | translate }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Test Rule Modal -->
<div
  class="modal fade"
  id="testModel"
  tabindex="-1"
  aria-labelledby="testModelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" id="testModelLabel">
          {{ "RULESCOMPONENT.MODAL.TITLE" | translate }}
        </h6>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body table-responsive">
        <div class="row g-3">
          <!-- Left Column -->
          <div class="col-12">
            <form #uiForm="ngForm">
              <div class="row g-2 mb-3 align-items-center">
                <div class="col-12">
                  <label class="form-label mb-0"
                    >{{ "RULESCOMPONENT.MODAL.NAME" | translate }}:</label
                  >
                </div>
                <div class="col-12 compact-inputs dropdown-pd-none">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select
                      #field
                      name="applicationRole"
                      [ngModel]="testform.data['id']"
                      (ngModelChange)="
                        testform.data['id'] = $event; onSelectRow($event)
                      "
                      (selectionChange)="onSelectRow($event.value)"
                    >
                      <mat-option [value]="0">
                        {{ "RULESCOMPONENT.MODAL.SELECT" | translate }}
                      </mat-option>
                      <ng-container *ngFor="let c of form.list">
                        <mat-option [value]="c.id">{{ c.name }}</mat-option>
                        <mat-option [value]="c.id + ''" style="display: none">{{
                          c.name
                        }}</mat-option>
                      </ng-container>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label mb-1"
                  >{{ "RULESCOMPONENT.MODAL.RULE" | translate }}:</label
                >
                <div class="rule-display-card">
                  <div class="p-0">
                    <pre
                      class="card shadow-none card-body rule-pre mb-0 ps-2"
                      >{{ testform.data["rule"] }}</pre
                    >
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="d-flex justify-content-between mb-2">
                  <label class="form-label"
                    >{{
                      "RULESCOMPONENT.MODAL.INPUT_LABEL" | translate
                    }}:</label
                  >
                  <button
                    mat-stroked-button
                    color="primary"
                    type="button"
                    (click)="addInput()"
                  >
                    <mat-icon>add</mat-icon>
                    {{ "RULESCOMPONENT.MODAL.ADD_INPUT" | translate }}
                  </button>
                </div>

                <div class="card shadow-none border">
                  <div class="card-body p-3">
                    <div
                      *ngFor="let key of inputKeys; let i = index"
                      class="row g-2 mb-2 align-items-center compact-inputs dropdown-pd-none"
                    >
                      <div class="col-md-5 col-lg-4">
                        <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            type="text"
                            [(ngModel)]="inputKeys[i]"
                            placeholder="Key"
                            [name]="'key_' + i"
                          />
                        </mat-form-field>
                      </div>
                      <div class="col-md-5 col-lg-6">
                        <mat-form-field appearance="outline" class="w-100">
                          <input
                            matInput
                            type="text"
                            [(ngModel)]="input_data[inputKeys[i]]"
                            placeholder="Value"
                            [name]="'value_' + i"
                          />
                        </mat-form-field>
                      </div>
                      <div class="col-md-2 col-lg-2 text-center text-md-start">
                        <div class="d-grid d-md-block">
                          <button
                            mat-stroked-button
                            color="warn"
                            type="button"
                            class="icon-center icon-width"
                            (click)="inputKeys.splice(i, 1)"
                          >
                            <mat-icon class="icon-compact">delete</mat-icon>
                            <span class="d-block d-md-none">Delete</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <!-- Right Column - Results -->
          <!-- <div class="col-xl-4 col-lg-12">
            <div *ngIf="testform.success" class="h-100">
              <div class="card h-100">
                <div class="card-header">
                  <h3 class="h6 mb-0">{{ 'RULESCOMPONENT.MODAL.RESULT' | translate }}:</h3>
                </div>
                <div class="card-body">
                  <pre class="mb-0 overflow-auto" style="max-height: 250px">{{ testform.result }}</pre>
                </div>
              </div>
            </div>
           
          </div> -->
        </div>
      </div>

      <div class="modal-footer">
        <div class="mb-2">
          <button
            mat-stroked-button
            color="primary"
            type="button"
            class="btn-sm me-2"
            (click)="execute('sum')"
          >
            <mat-icon>add</mat-icon>
            {{ "RULESCOMPONENT.MODAL.EXECUTE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
